import React from 'react';
import { Link } from 'react-router-dom';
import { Shell } from '../components/Shell';

export default function PaymentFailurePage() {
  return (
    <Shell narrow>
      <div className="card-accent text-center animate-in">
        <div className="mx-auto w-12 h-12 rounded-full bg-amber-100 text-amber-600 flex items-center justify-center text-xl mb-4">!</div>
        <p className="text-lg font-bold text-ink">Payment cancelled</p>
        <p className="text-sm text-muted mt-2">Nothing was charged. Try again when ready.</p>
        <Link to="/" className="btn mt-6 inline-flex">Back to search</Link>
      </div>
    </Shell>
  );
}
